<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-3 pb-0">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-card>
      <b-row class="mb-2">

        <b-col
          cols="12"
          md="9"
        >
          <div class="form-group">
            <label>
              <strong>Search</strong>
            </label>
            <b-input
              v-model="tableOrganizations.filter.search"
              type="text"
              placeholder="search here"
              debounce="1000"
            />
          </div>
        </b-col>

        <b-col
          cols="12"
          md="3"
        >
          <div class="form-group">
            <label>
              <strong>Company</strong>
            </label>
            <b-select
              v-model="tableOrganizations.filter.company"
              :options="filterCompanies"
            />
          </div>
        </b-col>

        <b-col
          cols="12"
        >
          <b-button
            type="button"
            variant="success"
            autocomplete="off"
            @click="onCreate"
          >
            Add Organization
          </b-button>
        </b-col>

      </b-row>

      <b-table
        ref="tableOrganizations"
        hover
        responsive
        class="mt-2"
        :per-page="tableOrganizations.perPage"
        :current-page="tableOrganizations.currentPage"
        :items="tableProvider"
        :fields="tableOrganizations.fields"
        :sort-by.sync="tableOrganizations.sortBy"
        :sort-desc.sync="tableOrganizations.sortDesc"
        :sort-direction="tableOrganizations.sortDirection"
        :filter="tableOrganizations.filter"
        :filter-included-fields="tableOrganizations.filterOn"
        show-empty
      >
        <template #cell(index)="data">
          {{ tableOrganizations.currentPage * tableOrganizations.perPage - tableOrganizations.perPage + (data.index + 1) }}
        </template>

        <template #cell(active)="data">
          {{ data.item.active == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell()="data">
          <div class="text-nowrap">
            {{ data.value }}
          </div>
        </template>

        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="primary"
            @click="onEdit(row.item)"
          >
            Edit
          </b-button>
        </template>

      </b-table>
      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableOrganizations.perPage"
              :options="tableOrganizations.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableOrganizations.currentPage"
            :total-rows="tableOrganizations.totalRows"
            :per-page="tableOrganizations.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-organization-form"
      scrollable
      no-close-on-backdrop
      no-enforce-focus
      aria-hidden="false"
      :title="modalTitle"
      @ok="onValidate"
    >
      <ValidationObserver
        ref="formOrganization"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <ValidationProvider
            #default="{ errors }"
            name="company"
            vid="company"
            rules="required"
          >
            <b-form-group>
              <label for="company">
                <strong>Company</strong>
              </label>
              <b-form-select
                id="company"
                v-model="organization.company"
                type="text"
                :options="list.companies"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- Please Select Company --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
                v-text="errors[0]"
              />
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="organization code"
            vid="organization_code"
            rules="required|max:13"
          >
            <div class="form-group">
              <label for="organization_code">
                <strong>Code</strong>
              </label>
              <b-input
                id="organization_code"
                v-model="organization.organization_code"
                type="text"
                placeholder="enter organization code"
                autocomplete="off"
                maxlength="13"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy || state.editing"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
                v-text="errors[0]"
              />
            </div>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="organization name"
            vid="organization_name"
            rules="required|max:150"
          >
            <div class="form-group">
              <label for="organization_name">
                <strong>Name</strong>
              </label>
              <b-input
                id="organization_name"
                v-model="organization.organization_name"
                type="text"
                placeholder="enter organization name"
                autocomplete="off"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
                v-text="errors[0]"
              />
            </div>
          </ValidationProvider>

          <div
            v-if="state.editing"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="organization.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              switch
              :disabled="state.busy"
            >
              <strong>Is Active?</strong>
            </b-form-checkbox>
          </div>

        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          @click="ok()"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="outline-dark"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>
<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AxiosError, SAdminOrganization, SSharedList } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'VAdminOrganizations',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Organizations'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        editing: false,
        busy: false
      },
      list: {
        companies: []
      },
      organization: {
        id: 0,
        organization_code: '',
        organization_name: '',
        company: null,
        active: 0
      },
      tableOrganizations: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: '',
          company: 'All'
        },
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'organization_code', sortable: true },
          { key: 'organization_name', sortable: true },
          { key: 'company_name', sortKey: 'companies.company_name', label: 'company', sortable: true },
          { key: 'active' },
          { key: 'updated_at', formatter: this.dateTimeFormatter, sortable: true }
        ]
      }
    }
  },

  computed: {
    modalTitle () {
      return this.state.editing ? 'Edit Organization' : 'New Organization'
    },

    filterCompanies () {
      return [{ value: 'All', text: 'All' }].concat(this.list.companies)
    }
  },

  mounted () {
    core.index()
    this.getOptions()
  },

  methods: {
    async tableProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableOrganizations.busy = true
      const filters = this.objectToUrl({
        page: currentPage,
        per_page: perPage,
        sort: sortBy,
        sort_desc: sortDesc,
        filter_company: filter.company,
        filter_text: filter.search
      })

      return await SAdminOrganization.get(filters).then(
        ({ data }) => {
          this.tableOrganizations.totalRows = data.total_rows
          return data.items
        }
      )
        .catch(() => {
          this.tableOrganizations.totalRows = 0
          return []
        })
        .finally(() => {
          this.tableOrganizations.busy = false
        })
    },

    async getOptions () {
      await SSharedList.getCompanies().then(
        ({ data }) => {
          this.list.companies = data.map(
            ({ id, company_name }) => ({
              text: company_name,
              value: id
            })
          )
        }
      ).catch(() => {
        this.list.companies = []
      })
    },

    onCreate () {
      this.state.editing = false
      this.organization.organization_code = ''
      this.organization.organization_name = ''
      this.organization.company = null
      this.organization.active = 1
      this.$bvModal.show('modal-organization-form')
    },

    onEdit (item) {
      this.state.editing = true
      this.organization.id = item.id
      this.organization.organization_code = item.organization_code
      this.organization.organization_name = item.organization_name
      this.organization.company = item.company_id
      this.organization.active = item.active
      this.$bvModal.show('modal-organization-form')
    },

    async onValidate (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.formOrganization.validate().then(
        async areAllFieldsValid => {
          if (areAllFieldsValid) {
            this.$swal.fire({
              icon: 'question',
              title: 'Confirmation',
              text: this.state.editing ? 'Update Position?' : 'Create Position?',
              confirmButtonColor: '#06C270',
              confirmButtonText: 'Confirm',
              cancelButtonColor: '#737373',
              showCancelButton: true,
              showLoaderOnConfirm: true,
              preConfirm: () => {
                this.state.busy = true
                if (this.state.editing) {
                  return this.onPut()
                }

                return this.onPost()
              },
              allowOutsideClick: () => !this.$swal.isLoading()
            })
          } else {
            this.$bvModal.msgBoxOk('Oops! There were problem with your inputs.', {
              title: 'Validation Error',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              centered: true
            })
          }
        }
      )
    },

    async onPost () {
      return new Promise(
        resolve => {
          SAdminOrganization.post(this.organization).then(
            ({ data }) => {
              this.$bvModal.hide('modal-organization-form')
              this.$swal.fire({
                icon: 'success',
                title: 'Successful',
                text: data.message,
                confirmButtonColor: '#06C270',
                confirmButtonText: 'Dismiss'
              }).then(() => {
                this.$refs.tableOrganizations.refresh()
              })
            }
          ).catch(
            error => {
              if (error instanceof AxiosError) {
                if (error.code === 422) {
                  this.$refs.formOrganization.setErrors(error.message)
                }
              }
            }
          ).finally(resolve)
        }
      ).then(() => {
        this.state.busy = false
      })
    },

    async onPut () {
      return new Promise(
        resolve => {
          SAdminOrganization.put(this.organization).then(
            ({ data }) => {
              this.$bvModal.hide('modal-organization-form')
              this.$swal.fire({
                icon: 'success',
                title: 'Successful',
                text: data.message,
                confirmButtonColor: '#06C270',
                confirmButtonText: 'Dismiss'
              }).then(() => {
                const row = _.find(this.$refs.tableOrganizations.localItems, {
                  id: data.organization.id
                })
                row.organization_code = data.organization.organization_code
                row.organization_name = data.organization.organization_name
                row.company_id = data.organization.company_id
                row.company_name = data.organization.company.company_name
                row.active = data.organization.active
                row.updated_at = data.organization.updated_at
              })
            }
          ).catch(
            error => {
              if (error instanceof AxiosError) {
                if (error.code === 422) {
                  this.$refs.formOrganization.setErrors(error.message)
                }
              }
            }
          ).finally(resolve)
        }
      ).then(() => {
        this.state.busy = false
      })
    }
  }
}
</script>
